module.exports = __webpack_public_path__ + "static/img/体检报告@3x.4978e22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/体检报告@3x.png
// module id = 784
// module chunks = 382